var map = {
	"./Type_Bug.png": "ce4d",
	"./Type_Dark.png": "f221",
	"./Type_Dragon.png": "dcac",
	"./Type_Electric.png": "1ff5",
	"./Type_Fairy.png": "8c4b",
	"./Type_Fighting.png": "08eb",
	"./Type_Fire.png": "24d7",
	"./Type_Flying.png": "1089",
	"./Type_Ghost.png": "313c",
	"./Type_Grass.png": "eae7",
	"./Type_Ground.png": "c17a",
	"./Type_Ice.png": "6f4b",
	"./Type_Normal.png": "5208",
	"./Type_Poison.png": "1296",
	"./Type_Psychic.png": "cf22",
	"./Type_Rock.png": "7ddc",
	"./Type_Steel.png": "960e",
	"./Type_Water.png": "ce76"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2442";